<template>
    <div>
        <div class="row mt-0">
            <div class="col-3">
                <app-input-text label="Total de formatos" :icon="true" :contentType="15" id="formatos_total"
                    :value="formatoView.toString()" />
            </div>
            <div class="col-3">
                <app-input-text label="Total por segmentos" :icon="true" :contentType="15" id="segmentos_total"
                    :value="segmentoView.toString()" />
            </div>
            <div class="col-3">
                <app-input-text label="Qtda. de pecas templatizadas" :icon="true" :contentType="15"
                    id="templatizadas_total" :value="templatizadasView.toString()" />
            </div>
            <div class="col-3">
                <app-input-text label="Indice de templatização" :icon="true" :contentType="15" id="indice"
                    :value="templatizadasIndice" />
            </div>
            <div class="col-3">
                <app-input-text label="Qtda. de peças correntistas" :icon="true" :contentType="15" id="correntista"
                    :value="correntistasView.toString()" />
            </div>
        </div>
    </div>
</template>

<script>
import AppInputText from "@/components/AppInputText/AppInputTextFormats.vue";
export default {
    props: {
        segmento: { type: [Number, String], required: false, default: 0 },
        nao_correntistas: { type: [Number, String], required: false, default: 0 },
        items: { type: Array, default: () => [] }
    },
    components: {
        AppInputText
    },
    computed: {
        segmentoView() {
            return Number(this.segmento) || 0
        },
        formatoView() {
            return this.sumFormatos(this.items)
        },
        templatizadasView() {
            return this.sumTemplates(this.items)
        },
        templatizadasIndice() {
            if (this.formatoView === 0) return '0%';
            return ((this.templatizadasView / this.formatoView) * 100).toFixed(2) + '%';
        },
        naoCorrentistasView(){
            console.log('naoCorrentistasView',this.nao_correntistas)
            return this.nao_correntistas;
        },
        correntistasView() {
            const value = this.formatoView - Number(this.naoCorrentistasView);
            return value >= 0 ? value : 0;
        }
    },
    methods: {
        sumFormatos(data) {
            if (!Array.isArray(data)) return 0
            return data.reduce((acc, obj) => acc + Number(obj.qtda || 0), 0)
        },
        sumTemplates(data) {
            if (!Array.isArray(data)) return 0
            return data.reduce((acc, obj) => acc + Number(obj.qtda_templatizada || 0), 0)
        },
        
    }
}
</script>